import { createApi } from "@reduxjs/toolkit/query/react";
import { baseAuthQuery } from "../base/baseApi";
import { ApiResponse } from "../base/apiResponse";
import {
  FilterDto,
  ScheduleRequest,
  ScheduleResponse,
  ScheduleSubjectResponse,
} from "../../models/dtos";

export const scheduleApi = createApi({
  reducerPath: "schedulesApi",
  baseQuery: baseAuthQuery("schedules"),
  tagTypes: ["Schedule"],
  endpoints: (builder) => ({
    getSchedules: builder.query<ApiResponse<ScheduleResponse[]>, Partial<FilterDto>>({
      query: (_query) => {
        return {
          url: "/GetSchedules",
          method: "GET",
        };
      },
      providesTags: (_result, _error, filter) => {
        if (filter) {
          return [{ type: "Schedule", id: JSON.stringify(filter) }];
        }
        return ["Schedule"];
      },
    }),
    getSchedulesByFacSpec: builder.query<ApiResponse<ScheduleResponse[]>, { facultyId: number; specialityId: number }>({
      query: ({ facultyId, specialityId }) => ({
        url: "",
        method: "GET",
        params: { facultyId, specialityId },
      }),
      providesTags: (_result, _error) => {
        return ["Schedule"];
      },
    }),
    getScheduleById: builder.query<ApiResponse<ScheduleResponse>, number>({
      queryFn: async (scheduleId, _queryApi, _extraOptions, baseQuery) => {
        if (Number.isNaN(scheduleId)) {
          return {
            data: { data: {} } as ApiResponse<ScheduleResponse>,
            error: undefined,
          };
        }
        const response = await baseQuery({
          url: `/${scheduleId}`,
          method: "GET",
        });
        if (response.error) {
          return { error: response.error };
        }
        return { data: response.data as ApiResponse<ScheduleResponse> };
      },
      providesTags: (_result, _error, id) => {
        return [{ type: "Schedule", id: id }];
      },
    }),
    getScheduleWithSubjectsById: builder.query<ApiResponse<ScheduleSubjectResponse>, number>({
      query: (id) => `/${id}/withSubjects`,
      providesTags: (_result, _error, id) => {
        return [{ type: "Schedule", id: id }];
      },
    }),
    updateSchedule: builder.mutation<ApiResponse<number | null>, Partial<ScheduleRequest>>({
      query: (body) => ({
        url: "CreateOrUpdateScheduleParams",
        method: "POST",
        body,
      }),
      invalidatesTags: (result, _error, _body) => [
        { type: "Schedule", id: result?.data?.toString() },
        { type: "Schedule" },
      ],
    }),
    createScheduleFromCopy: builder.mutation<ApiResponse<number>, number>({
      query: (body) => {
        return {
          url: `CreateFromCopy/${body}`,
          method: "POST",
        };
      },
    }),
    deleteSchedule: builder.mutation<ApiResponse<boolean>, number>({
      query: (body) => {
        return {
          url: `DeleteSchedule/${body}`,
          method: "POST",
        };
      },
      invalidatesTags: (_result, _error) => [{ type: "Schedule" }],
    }),
  }),
});
